import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["children"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { getBackgroundShade, pxToRem } from 'utils/ui';
import ButtonCore from 'components/ButtonCore';
import Icon from 'components/Icon';
import { textLinkStyles, textLinkProps } from 'components/TextLink';
import Divider from 'components/Divider';
import Text from 'components/Text';
var Wrapper = styled.ul.withConfig({
  displayName: "MenuList__Wrapper",
  componentId: "sc-5xnnyi-0"
})(["display:block;padding:", " 0;list-style:none;font-weight:400;line-height:", ";&:empty{display:none;}&:focus{outline:none;}"], function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.theme.globals.lineHeight;
});
var Item = styled.li.withConfig({
  displayName: "MenuList__Item",
  componentId: "sc-5xnnyi-1"
})(["position:relative;display:block;"]);
var Link = styled(ButtonCore).attrs(function (_ref) {
  var isHighlighted = _ref.isHighlighted;
  return {
    className: isHighlighted ? 'is-highlighted' : '',
    stealthy: true
  };
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return ![].concat(_toConsumableArray(textLinkProps), ['isHighlighted']).includes(prop);
  }
}).withConfig({
  displayName: "MenuList__Link",
  componentId: "sc-5xnnyi-2"
})(["position:relative;display:flex;align-items:center;white-space:nowrap;width:100%;padding:", " ", ";", " cursor:pointer;transition:none;&:hover:not(.is-disabled),&:focus:not(.is-disabled){color:inherit;text-decoration:none;background-color:", ";outline:none;}", "[data-focus-visible-added] &&.is-highlighted,&[data-focus-visible-added]:focus{outline:none;&::after{content:'';position:absolute;left:0;top:0;height:100%;width:", ";background-color:", ";}}", " &.is-active:not(.is-disabled){font-weight:600;}&.is-disabled{opacity:0.5;color:inherit;text-decoration:none;cursor:default;}"], function (p) {
  return p.theme.globals.spacing.xxs;
}, function (p) {
  return p.theme.globals.spacing.s;
}, textLinkStyles, function (p) {
  return getBackgroundShade(p.theme);
}, Wrapper, pxToRem(4), function (p) {
  return p.theme.links;
}, function (p) {
  return p.isHighlighted && css(["background-color:", ";"], function (p) {
    return getBackgroundShade(p.theme);
  });
});
var IconWrapper = styled.span.withConfig({
  displayName: "MenuList__IconWrapper",
  componentId: "sc-5xnnyi-3"
})(["flex:none;vertical-align:middle;margin-right:", ";opacity:", ";", ":hover:not(.is-disabled) > &&,", "[data-focus-visible-added]:not(.is-disabled) > &&,.is-active:not(.is-disabled) > &&{opacity:1;}"], function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return p.theme.textDimStrength;
}, Link, Link);
var ItemIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    vAlign: true
  }, props)));
});
ItemIcon.displayName = 'ItemIcon';
var ItemDivider = function ItemDivider(props) {
  return /*#__PURE__*/React.createElement(Divider, _extends({}, props, {
    my: "xs",
    role: "separator"
  }));
};
ItemDivider.displayName = 'ItemDivider';
var GroupLabel = function GroupLabel(props) {
  var children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "div"
  }, otherProps, {
    bold: true,
    size: "xxs",
    lineHeight: 1.2,
    px: "s",
    pt: "xxs",
    pb: 6
  }), children);
};
export { Wrapper, Item, ItemIcon, Link, ItemDivider, GroupLabel };